<template>
  <Modal
    class="tagsModal newModal"
    v-model="workshopPop"
    :title="`${title} `"
    width="500px"
    :mask-closable="false"
    @on-cancel="cancelPop"
  >
    <div slot="header" class="u-flex" > 
      <span class="headtitle">{{ title }}</span>
      <!-- <span class="mrfont">{{ khname || curItemDetail.consumerName }}</span> -->
      <div class="workimgadd" style="margin-top:0;margin-left:20px">
            <img
              src="../../../assets/images/add.png"
              style="width: 12px; height: 12px"
            />
            <div class="addinput pot" @click="addinputd">新增</div>
          </div>
    </div>
    <div class="tagsWrap">
      <!-- <ul class="curTags" v-if="curNewTags.length">
                 <li :class="['seled',{opac:isManager}]" v-for="label in curNewTags" :key="label.id">
                    <span :key="label.id">{{label.value || '--'}}</span>
                    <Icon @click="delSeledTag(label.id)" type="md-close-circle" v-if="!isManager" />
                </li>
            </ul> -->
      <div class="addWrap">
        <div class="items-width">
          <div v-for="(label, index) in workShopLists" :key="index">
            <div class="flex">
              <Input
                v-model="label.value"
                maxlength="12"
                placeholder="请输入设备组名称 (最多12个字)"
              >
                <!-- <Button @click="addNewLabel" slot="append" :disabled="isManager">新增</Button> -->
              </Input>
              <div @click="remove(label.id)" class="append">删除</div>
            </div>
          </div>
          <!-- <div class="workimgadd">
            <img
              src="../../../assets/images/add.png"
              style="width: 12px; height: 12px"
            />
            <div class="addinput pot" @click="addinputd">新增</div>
          </div> -->
        </div>
      </div>
    </div>

    <div slot="footer">
      <!-- @click="surePop" -->
      <Button @click="okPop" type="primary">提交</Button>
      <Button @click="cancelPop">取消</Button>&nbsp;
    </div>
    <Spin size="large" fix v-if="wrapLoading"></Spin>
  </Modal>
</template>

<script>
import api from "@/api";

export default {
  name: "worshopmodal",
  props: {
    workshopPop: Boolean,
    closePop: Function,
    setWorkshopId: Function,
    refreshWorkshop: Function,
    curWorkShops: Array,
    curItemDetail: Object,
    formData: Object,
    khname: [String, Number],
  },
  data() {
    return {
      title: "编辑设备组 ",
      newTag: "", //新增设备组
      curNewTags: [], //当前选中的设备组组
      selTags: "", //选择的删除设备组
      isManager: false, //管理设备组
      workShopLists: [], //设备组库集合
      lsLoading: false,
      curSeledTenantId: null,
      wrapLoading: false,
      btnLoading: false,
    };
  },
  created() {
    this.getLabels();
  },
  mounted() {},
  methods: {
    addinputd() {
      this.workShopLists.unshift({
        value: "",
        id: "",
      });
    },
    okPop() {
      let finalList = [];
      //curItemDetail.consumerTenantId
      this.workShopLists.forEach((item) => {
        if (item.value) {
          finalList.push({
            type: "workShop",
            gangedValueMap: {
              tenantId: this.curSeledTenantId,
            },
            //   tenantId:this.curItemDetail.consumerTenantId,
            value: item.value,
            id: item.id,
          });
        }
      });
      // finalList["type"]=""
      api.axss("post", "/ocm-admin/dict/add", finalList).then((res) => {
        if (res.code === "00000") {
          this.newTag = "";
          this.getLabels();
          this.refreshWorkshop();
          this.$store.dispatch("listCollection", "workShop");
          this.cancelPop();
          this.$emit("end");
          this.$Message.success("提交成功");
        }
      });
    },
    remove(id) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>您确定要删除该设备组吗？</p>",
        onOk: () => {
          if (id) {
            this.selTags = id;
            this.$nextTick(() => {
              this.delStoreLabels();
            });
          } else this.workShopLists.pop();
        },
        onCancel: () => {},
      });
    },
    getLabels() {
      this.lsLoading = true;
      this.$nextTick(() => {
        api
          .axss("post", "/ocm-admin/dict/page", {
            size: 200,
            type: "workShop",
            gangedValueMap: {
              tenantId: this.formData.tenantId,
            },
          })
          .then((res) => {
            if (res.code === "00000") {
              let lists = res.data.records;
              // lists.forEach((item, index) => {
              //     this.curNewTags.forEach((ite) => {
              //         if (item.id === ite.id) lists.splice(index, 1); // lists[index].checked = true
              //     });
              // });
              // lists.push({
              //     value: "",
              //     id: "",
              // });
              this.workShopLists = lists;
              this.lsLoading = false;
            }
          });
      });
    },

    delStoreLabels() {
      // if (!this.selTags)
      //     return this.$Message.info("请至少选择一个品牌");
      this.wrapLoading = true;
      api
        .axss(
          "get",
          "/ocm-admin/dict/delDeviceCombine",
          {},
          { id: this.selTags }
        )
        .then((res) => {
          if (res.code === "00000") {
            // this.selTags = [];
            this.getLabels();
            this.refreshWorkshop();
          } else {
            this.$Message.error(res.msg);
          }
          this.wrapLoading = false;
        });
    },

    cancelPop() {
      this.closePop();
      this.curNewTags = [];
      this.newTag = "";

      this.getLabels();
    },
  },
  watch: {
    formData: {
      handler: function (newValue, oldValue) {
        this.curSeledTenantId = this.formData.tenantId;

        //  this.curSeledTenantId = newValue.tenantId // 处理新增时的id问题
        if (newValue.tenantId && newValue.workshopId)
          this.curNewTags = [
            {
              id: newValue.workshopId,
              value: newValue.workshopName,
            },
          ];
        else{
          this.curNewTags = [];
        } 
      
      },
      deep: true,
    },
    workshopPop: {
      handler: function (newValue, oldValue) {
        this.getLabels();
          var modal = document.getElementsByClassName("items-width")[0];
      
          modal.scrollTop = 0;
      },
      deep: true,
    },
  },
};
</script>
<style>
/*滚动条样式*/
/* .items-width::-webkit-scrollbar {
    width: 4px;
   
}

.items-width::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
}

.items-width::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
} */
</style>
<style lang='less'>
.tagsModal {
  .tagsWrap {
    position: relative;

    .curTags {
      display: flex;
      flex-wrap: wrap;

      li {
        position: relative;
        font-size: 12px;
        color: #444;
        background: #f2f2f2;
        border-radius: 10px;
        padding: 2px 8px;
        margin-right: 14px;
        margin-bottom: 10px;

        span {
          font-size: 12px;
        }

        .ivu-icon {
          position: absolute;
          top: -8px;
          right: -5px;
          font-size: 16px;
          color: #aaa;
          cursor: pointer;
        }

        &.seled {
          color: #0c479d;
          background: #d0e5f7;
        }

        &.opac {
          opacity: 0.4;
        }
      }
    }

    .addWrap {
      margin: 10px 0;

      .ivu-input-wrapper {
        .ivu-input-word-count {
          color: #ccc;
          right: 66px;
          z-index: 3;
        }
      }

      .ivu-input-group-append {
        .ivu-btn {
          box-shadow: none;
        }
      }
    }

    .tagsManage {
      display: flex;
      margin: 20px 0 10px;

      h4 {
        font-size: 14px;
      }

      .manage {
        margin-left: auto;
        font-size: 14px;

        .ivu-icon {
          font-size: 16px;
        }
      }
    }

    .storeWrap {
      position: relative;
      border: 1px solid #dcdee2;
      border-radius: 6px;
      padding: 10px 8px 0;
      min-width: 44px;
      height: 118px;
      // max-height: 118px;
      overflow-y: auto;

      .noDatas {
        color: #ccc;
        text-align: center;
        padding-top: 35px;
      }
    }
  }
}

.items-width {
  height: 300px;
  overflow: auto;
  padding-right: 8px;
}

.flex {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  .append {
    width: 28px;
    margin-left: 12px;
    text-align: right;
    color: #0c479d;
    cursor: pointer;
    margin-top: 0px;
    font-size: 12px;
  }
}

.workimgadd {
  display: flex;
  font-size: 12px;

  font-weight: 400;
  color: #0070cc;
  line-height: 8px;
  margin-top: 21px;
  align-items: center;

  div {
    margin-left: 3px;
  }
}

.headtitle {
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: #17233d;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mrfont {
  font-size: 16px;

  font-weight: 400;
  color: #adadad;
  margin-left: 12px;
}

.addinput {
  font-size: 12px;

  font-weight: 400;
  color: #0070cc;
  line-height: 8px;
  -webkit-background-clip: text;
}
</style>